import { Route, Routes } from "react-router-dom";
import ProductsPage from "../../pages/main/products/page";
import ProductPage from "../../pages/main/products/details";


export default function ProductNav() {
  return (
    <Routes>

      <Route path="/" element={<ProductsPage />} />
      <Route path="/:slug" element={<ProductPage />} />


    </Routes>
  )
}
